function AltLink() {
  return (
    <blockquote className="p-4 bg-white">
      <h4 className="h6 mb-3">What It Means</h4>
      <p>A skip navigation link exists, but the target for the link does not exist or the link is not keyboard accessible.</p>
      <h4 className="h6 mb-3">Why It Matters</h4>
      <p>A link to jump over navigation or jump to the main content of the page assists keyboard users only if the link is properly functioning and is keyboard accessible.</p>
      <h4 className="h6 mb-3">What To Do</h4>
      <p>Ensure that the target for the link exists and that the link is not hidden with CSS display:none or visibility:hidden.</p>
    </blockquote>
  )
}

export default AltLink